import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid, Snackbar, Alert, Typography } from '@mui/material';
import { getDatabase, ref, push, set, get } from 'firebase/database';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';

const db = getDatabase();

const addClient = async (client) => {
  const clientsRef = ref(db, 'clients');
  const newClientRef = push(clientsRef);
  await set(newClientRef, client);
};

const fetchClients = async () => {
  const clientsRef = ref(db, 'clients');
  const snapshot = await get(clientsRef);
  const clients = [];
  if (snapshot.exists()) {
    snapshot.forEach((childSnapshot) => {
      clients.push({ id: childSnapshot.key, ...childSnapshot.val() });
    });
  }
  return clients;
};

const AddClient = () => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [description, setDescription] = useState('');
  const [clients, setClients] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Use useNavigate for redirection

  useEffect(() => {
    // Check for logged-in status on component mount
    if (!localStorage.getItem('LOGGED_IN')) {
      navigate('/'); // Redirect to home if not logged in
    }

    const getClients = async () => {
      const clientsList = await fetchClients();
      setClients(clientsList);
    };
    getClients();
  }, [navigate]);

  const handleSave = async () => {
    // Remove the error message when attempting to save
    setError('');

    if (!name || !number || !description) {
      setError('Należy wypełnić wszystkie pola!');
      return;
    }

    const phoneRegex = /^[0-9+ ]*$/;
    if (!phoneRegex.test(number)) {
      setError('Proszę wpisać prawidłowy numer telefonu zawierający tylko cyfry, spacje i opcjonalnie znak "+"');
      return;
    }

    const client = {
      name,
      number,
      description,
    };

    await addClient(client);

    setName('');
    setNumber('');
    setDescription('');

    const clientsList = await fetchClients();
    setClients(clientsList);
    
    // Show Snackbar after saving the client
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <div>
      <Navbar />
      <div className="container" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <h1>Dodaj Klienta</h1>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Imię i Nazwisko"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              margin="normal"
              error={!!error && !name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Numer Telefonu"
              variant="outlined"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              fullWidth
              margin="normal"
              helperText="Tylko cyfry i znak '+' są dozwolone"
              type="tel"
              error={!!error && !number}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Opis"
              variant="outlined"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              margin="normal"
              error={!!error && !description}
            />
          </Grid>
          <Grid item xs={12}>
            {error && (
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            )}
            <Button variant="contained" color="primary" onClick={handleSave}>
              Zapisz Klienta
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={2000}
          onClose={handleSnackbarClose}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            borderRadius: '8px',
          }}
        >
          <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%', color: 'white', backgroundColor: '#004d00' }}>
            Poprawnie dodano klienta
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default AddClient;
